<template>
<div class="promo-campaign">
  <div class="promo-campaign-banner">
    <div class="promo-campaign-banner__slide" v-for="index in 40" :key="index">
      {{  $t('calculator.promotion-campaign.banner-text') }}
    </div>
  </div>
  <div class="promo-campaign-timer">
    <p class="promo-campaign-timer-title">
      {{  $t('calculator.promotion-campaign.timer-title') }}
    </p>
    {{ promoTimer }}
  </div>
  <CalculatorBuyNow class="promo-campaign-cta" :link-params="{ promoCode: promoInfo.code }">
    {{  $t('calculator.promotion-campaign.cta-button-label', {
    cryptoName: selectedCryptoName
  }) }}
  </CalculatorBuyNow>
  <div class="promo-campaign-disclaimer">
    {{  $t('calculator.promotion-campaign.disclaimer') }}
  </div>
</div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from "vue";
import store from '@/store/calculator';
import CalculatorBuyNow from "@/components/Calculator/CalculatorBuyNow.vue";

const props = defineProps<{
  promoInfo: { code: string, expirationDate: Date } | null,
}>();

const getPromoExpirationTime = () => {
  const target = new Date(props.promoInfo.expirationDate);
  const now = new Date();

  const diffMs = target - now;

  if (diffMs <= 0) {
    window.clearInterval(promoTimerInterval);

    return "0h 0m 0s";
  }

  const totalSeconds = Math.floor(diffMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours}h ${minutes}m ${seconds}s`;
}

const selectedCryptoName = computed(() => store.state.calculator.selectedCryptoCurrency.name);
const promoTimer = ref(getPromoExpirationTime());
let promoTimerInterval = null;

onMounted(() => {
  if (props.promoInfo !== null) {
    promoTimerInterval = window.setInterval(() => { promoTimer.value = getPromoExpirationTime() }, 1000);
  }
});
onUnmounted(() => window.clearInterval(promoTimerInterval));
</script>

<style scoped lang="scss">
@keyframes slideshow {
  100% {
    -webkit-transform: translateX(-200%);
  }
}

.promo-campaign {
  margin: 30px 0;
  text-align: center;

  &-banner {
    padding: 8px 0;
    background: #BDF5A3;
    display: flex;
    flex-direction: row;
    overflow: hidden;

    &__slide {
      font-family: $font-bold;
      font-size: 22px;
      padding: 0 16px;
      flex-shrink: 0;
      transform: translate3d(0, 0, 0); /* Hey browser, please use my GPU */
      animation: slideshow 10s linear infinite;
    }
  }

  &-timer {
    margin-top: 20px;
    font-size: 18px;
    line-height: 28px;
    font-family: $font-bold;

    &-title {
      font-family: $font-regular;
      font-size: 14px;
    }
  }

  &-cta {
    margin: 20px;
    font-size: 18px;

    &:not(:hover) {
      background-color: #5F70DB;
      border-color: #5F70DB;
    }
  }

  &-disclaimer {
    color: #B3B3B3;
    font-size: 14px;
  }
}
</style>